import React from "react";
import { Link } from "react-router-dom";
import { Trophy, Target, Shield, Users } from "lucide-react";
import { PageHero, SectionHeading, FadeImg } from "@/components/Shared";
import { Button } from "@/components/ui/button";
import { aboutDefaults } from "@/pages/navPageDefaults";
import { useSiteContent } from "@/lib/siteContent";

const CARD_ICONS = [Trophy, Target, Shield, Users];
const img = (v) => (v && v.startsWith("http") ? v : v ? `${process.env.REACT_APP_BACKEND_URL}${v}` : "");

export default function About() {
  const content = useSiteContent();
  if (!content) return <div className="min-h-[60vh]" />;
  const c = { ...aboutDefaults, ...(content.about || {}) };

  return (
    <div data-testid="about-page">
      <PageHero title={c.title} subtitle={c.subtitle} image={img(c.hero_image)} testId="about-hero" />
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <SectionHeading eyebrow={c.story_eyebrow} title={c.story_title} className="mb-6" />
            <p className="text-slate-300 leading-relaxed whitespace-pre-line">{c.story_p1}</p>
            <p className="text-slate-300 leading-relaxed mt-4 whitespace-pre-line">{c.story_p2}</p>
          </div>
          <FadeImg src={img(c.story_image)} alt="Poker" className="border border-white/10 w-full h-80 object-cover" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {c.cards.map((card, i) => {
            const Icon = CARD_ICONS[i] || Trophy;
            return (
              <div key={i} className="bg-navy-paper border border-slate-800 p-6" data-testid={`about-card-${i}`}>
                <Icon className="w-8 h-8 text-gold mb-4" />
                <h3 className="font-display text-lg font-bold text-white">{card.title}</h3>
                <p className="text-slate-400 text-sm mt-2">{card.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 bg-navy-paper border border-gold/30 p-10 text-center">
          <h3 className="font-display text-2xl md:text-3xl font-bold text-white">{c.cta_title}</h3>
          <p className="text-slate-400 mt-2">{c.cta_text}</p>
          <div className="mt-6 flex flex-wrap gap-4 justify-center">
            <Link to="/events"><Button className="bg-gold text-navy hover:bg-gold-light rounded-none font-bold uppercase tracking-widest px-8 py-6">See Events</Button></Link>
            <Link to="/become-a-legend"><Button variant="outline" className="border-2 border-gold text-gold hover:bg-gold hover:text-navy rounded-none font-bold uppercase tracking-widest px-8 py-6 bg-transparent">Become a Legend</Button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
